import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewContainerRef,
} from '@angular/core';
import { declerationLinearText } from '../../../models/contitions';
import { UtilsService } from '../../../services/utils.service';
import { ModalDialogService } from 'ngx-modal-dialog';
import { AlgConditionModalComponent } from '../../dialogs/alg-condition-modal/alg-condition-modal.component';
import { AlgConsensoService } from '../../../services/alg-consenso.service';

@Component({
  selector: 'alg-option-gas',
  templateUrl: './alg-option-gas.component.html',
  styleUrls: ['./alg-option-gas.component.scss'],
})
export class AlgOptionGasComponent implements OnInit {
  @Input() checkboxesInput: Object = {};

  @Output() checkboxesOutputDeclare = new EventEmitter<boolean>();
  @Output() checkboxesOutputInformative = new EventEmitter<boolean>();
  @Output() checkboxes = new EventEmitter<boolean>();

  public informative: boolean;
  public decleration: boolean;
  public checkboxDeclareGas: boolean;
  public checkboxInformativeGas: boolean;

  public linearGasInformative =
    'https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/linear/Set_Informativo_ALG_OpzioneSicura_Gas.pdf';

  constructor(
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private consensoService: AlgConsensoService
  ) {}

  ngOnInit() {
    this.consensoService.gasLinearSubject$.subscribe((item) => {
      this.decleration = item;
    });
    this.consensoService.gasLinearInformative$.subscribe((item) => {
      this.informative = item;
    });
  }

  readCondition(type) {
    let modalContent;
    if (type === 'informative') {
      modalContent = declerationLinearText.gas;
    }
    if (type === 'clausole') {
      modalContent = declerationLinearText.clausoleGas;
    }
    this.openModal(modalContent || {});
  }

  openModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgConditionModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: modalContent.description,
      },
    });
  }

  declerationChecks(value) {
    if (value === 'informative') {
      this.informative = !this.informative;
      this.checkboxInformativeGas = !this.informative;
      this.checkboxesOutputInformative.emit(!this.informative);
      this.consensoService.updateGasInformative(this.informative);
    }
    if (value === 'declare') {
      this.decleration = !this.decleration;
      this.checkboxDeclareGas = !this.decleration;
      this.checkboxesOutputDeclare.emit(!this.decleration);
      this.consensoService.updateGasPolicy(this.decleration);
    }
    if (this.decleration && this.informative) {
      this.checkboxes.emit(true);
    } else {
      this.checkboxes.emit(false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-option-gas/alg-option-gas.component.ts